"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EActiveView = void 0;
let EActiveView = exports.EActiveView = /*#__PURE__*/function (EActiveView) {
  EActiveView["PhoneAuth"] = "phoneAuth";
  // Авторизации/регистрации по телефону. Здесь вводится номер телефона пользователя.
  EActiveView["PhoneAuthValidateSms"] = "phoneAuthValidateSms";
  // Экран проверки номера телефона по смс. Здесь пользователь вводит из смс код, чтобы подтвердить свой телефонный номер.
  EActiveView["PhoneAuthValidateCall"] = "phoneAuthValidateCall";
  // Экран проверки номера телефона по звонку. Здесь на указанный номер пользователя поступает телефонный звонок, а он вводит последние 4 цифры этого телефонного номера.
  EActiveView["AccountSelect"] = "accountSelect";
  // Экран выбора аккаунта. Здесь пользователь должен выбрать, хочет ли он авторизоваться по email, к которому уже привязан данный номер телефона, либо может "продолжить по телефону".
  EActiveView["ConfirmSelectedAccount"] = "confirmSelectedAccount";
  EActiveView["AccountSelectError"] = "accountSelectError";
  // Экран ошибки при выборе аккаунта
  EActiveView["TokenExpiredError"] = "tokenExpiredError";
  EActiveView["AuthenticationRegistration"] = "authenticationRegistration";
  // Экран авторизации/регистрации по email или id. Здесь пользователь вводит email или id.
  EActiveView["Agreement"] = "agreement";
  // Экран принятия пользовательского соглашения. Здесь пользователь ставит галочки о том, что он ознакомлен с пользовательским соглашением и принимает/отклоняет маркетинговую рассылку.
  EActiveView["SocialCreate"] = "socialCreate";
  // Экран подтверждения email и телефона для авторизации по соц сети. Здесь пользователь вводит свой email и телефон или изменяет email и телефон, которые "пришли" от соц сети. Email необходим для авторизации.
  EActiveView["SocialMerge"] = "socialMerge";
  // Экран мёржа аккаунта соц сети и существующего аккаунта Циан. Попадает на этот экран, если на шаге socialCreate пользователь ввёл email существующего аккаунта на Циан. В таком случае аккаунт соц сети и аккаунт Циан нужно объединить.
  EActiveView["TwoFactorWithPhone"] = "twoFactorWithPhone";
  // Экран ДФА, проверка по телефонному номеру. Пользователь вводит свой номер телефона, проверочный код отправляется по смс, либо по звонку.
  EActiveView["TwoFactorWithEmail"] = "twoFactorWithEmail";
  // Экран ДФА, проверка по email. Пользователь заходит с незнакомого ip адреса, проверочный код высылается письмом на email.
  EActiveView["TwoFactorPhoneValidateSms"] = "twoFactorPhoneValidateSms";
  // Экран проверки смс кода для прохождения ДФА. Здесь пользователь вводит из смс код, чтобы подтвердить свой телефонный номер.
  EActiveView["TwoFactorPhoneValidateCall"] = "twoFactorPhoneValidateCall";
  // Экран проверки номера телефона по звонку для прохождения ДФА. Здесь на указанный номер пользователя поступает телефонный звонок, а он вводит последние 4 цифры этого телефонного номера.
  EActiveView["TwoFactorAttemptsExhausted"] = "twoFactorAttemptsExhausted";
  EActiveView["Restore"] = "restore";
  EActiveView["ConfirmPhone"] = "confirmPhone";
  EActiveView["EmailSent"] = "emailSent";
  // Экран успешной отправки письма для подтверждения email-а при регистрации или восстановлении пароля
  EActiveView["RememberedAccountsSelect"] = "rememberedAccountsSelect";
  // Экран выбора из списка аккаунтов, в которые пользователь входил ранее на устройстве
  EActiveView["EnterPhoneNumber"] = "enterPhoneNumber";
  return EActiveView;
}({});